// 192px-Fassung statt des 1024er Originals (Okt 2026): angezeigt wird das
// Logo mit höchstens 64px, auch im Start-Spinner.
import OtterLogoImage from '../../assets/LOGO-192.png';

/**
 * Kompaktes Otter-Logo (reines Bild, ohne Hover-Effekte).
 *
 * Das Logo besteht aus dunklen Linien mit durchsichtiger Fuellung. Auf dunklem
 * Grund waere es damit fast unsichtbar. Im Dunkelmodus drehen wir es deshalb per
 * CSS-Filter auf Weiss: brightness(0) macht jeden Farbwert schwarz, invert(1)
 * daraus weiss — der Alphakanal bleibt unberuehrt, die feine Linienfuehrung also
 * erhalten. Dieselbe Technik nutzt OtterLogo.js.
 *
 * Fuer Flaechen, die IMMER dunkel sind (z. B. der Footer mit bg-gray-900),
 * reicht der Dunkelmodus-Filter nicht — dort zusaetzlich "brightness-0 invert"
 * ueber className mitgeben.
 */
const OtterCompactLogo = ({ className = '' }) => {
  return (
    <img
      src={OtterLogoImage}
      alt="Otter Logo"
      width={64}
      height={64}
      decoding="async"
      className={`dark:brightness-0 dark:invert ${className}`}
    />
  );
};

export default OtterCompactLogo;
